import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import auth from '../../../common/utility/auth';

import CustomTable from '../../../components/CustomTable';

const REGISTRADO = 1;
const APROBADO = 2;
const RECHAZADO = 3;
const ANULADO = 4;

export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idEstado === REGISTRADO)
            return 'blue';
        if (row.idEstado === APROBADO)
            return 'green';
        if (row.idEstado === RECHAZADO)
            return 'red';
        if (row.idEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onVer(row)}
                                />
                            </Tooltip>
                            {/* <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEditar(row)}
                                    disabled={!row.flag}
                                />
                            </Tooltip> */}
                            <Tooltip placement="top" title="Aprobar">
                                {auth.user().id == row.idRecepcion && row.idEstado === REGISTRADO ?
                                    <Button
                                        type="success"
                                        icon="check"
                                        size={"small"}
                                        onClick={() => props.onAprobar(row)}
                                    /> :
                                    <Button
                                        type="success"
                                        icon="check"
                                        size={"small"}
                                        onClick={() => props.onAprobar(row)}
                                        disabled={row.idEstado === APROBADO ? true : row.idEstado === ANULADO ? true : false}
                                    />
                                }

                            </Tooltip>
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    onClick={() => props.onAnular(row)}
                                    loading={props.loadingAnular}
                                    disabled={row.idEstado === APROBADO ? true : row.idEstado === ANULADO ? true : false}

                                />
                            </Tooltip>
                            {<Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    //disabled={row.idMovimientoIngreso == 0 ? true : false}
                                    loading={props.loadingPrint}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>}
                        </div>
                    )
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Almacén Origen',
                    dataIndex: 'almacenOrigen',
                    key: 'almacenOrigen',
                    sorter: true
                },
                {
                    title: 'Almacén Destino',
                    dataIndex: 'almacenDestino',
                    key: 'almacenDestino',
                    sorter: true
                },
                {
                    title: 'Encargado Recepción',
                    dataIndex: 'recepcion',
                    key: 'recepcion',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'nombreMoneda',
                    key: 'nombreMoneda',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreEstado',
                    key: 'nombreEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}
